//@flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { HighlightBox } from '../../../../atoms';

import { TicketAmount } from './ticket-amount';
import { TicketDue } from './ticket-due';
import { TicketBankAccount } from './ticket-bank-account';
import { TicketBankDestination } from './ticket-bank-destination';
import { TicketLineSeparator } from './ticket-line-separator';
import { TicketBankBeneficiary } from './ticket-bank-beneficiary';
import { TicketBankBeneficiaryDocument } from './ticket-bank-beneficiary-document';
import { TicketBankInternationalCode } from './ticket-bank-international-code.js';

export function Ticket(): Node {
  return (
    <Grid>
      <GridSlot name="amount">
        <TicketAmount />
      </GridSlot>
      <GridSlot name="due">
        <TicketDue />
      </GridSlot>
      <GridSlot name="account">
        <TicketBankAccount />
      </GridSlot>
      <GridSlot name="destination">
        <TicketBankDestination />
      </GridSlot>
      <GridSlot name="lineseparator">
        <TicketLineSeparator />
      </GridSlot>
      <GridSlot name="beneficiary">
        <TicketBankBeneficiary />
      </GridSlot>
      <GridSlot name="beneficiary_document">
        <TicketBankBeneficiaryDocument />
      </GridSlot>
      <GridSlot name="bank_international_code">
        <TicketBankInternationalCode />
      </GridSlot>
    </Grid>
  );
}

const GridSlot = styled(HighlightBox)`
  grid-area: ${props => props.name};
`;

const Grid = styled(HighlightBox)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas: "amount due"
                       "account destination"
                       "lineseparator lineseparator"
                       "beneficiary beneficiary_document"
                       "bank_international_code bank_international_code";
  ${GridSlot} {
    border-style: none;
    border-radius: 0;
    &:nth-child(1) {
      border-style: none solid solid none;
    }
    &:nth-child(2) {
      border-style: none none solid none;
    }
  }
`;
